const APPROVAL_REQUESTS = {
  curp: 'curp',
  identification: 'identification'
};

export default APPROVAL_REQUESTS;
